import { Mic } from 'lucide-react';

// Voice marker for a spoken turn — the Figma "Symphony Icon Button" (ghost) beside the bubble
// (node 14511:160571, User Bubble / Voice): a 30px transparent container carrying the 16px mic in
// the primary ink, at the DS icon spec (1.5px absoluteStrokeWidth). Not a button — it states that
// the turn was spoken, so it stays a role="img" marker rather than an IconButton.
export function MicGlyph({ title }: { title: string }) {
  return (
    <span title={title} aria-label={title} role="img" style={WRAP}>
      <Mic size={16} strokeWidth={1.5} absoluteStrokeWidth aria-hidden />
    </span>
  );
}

const WRAP: React.CSSProperties = {
  flexShrink: 0,
  width: 30,
  height: 30,
  borderRadius: 8,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'var(--sym-ink)',
};
